import React from "react";

// Reusable in-app confirmation dialog — replaces native window.confirm so it
// matches the app/embed theme. Controlled: render it with `open` + handlers.
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  busy = false,
  onConfirm,
  onClose,
}) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/50 p-4"
      onClick={busy ? undefined : onClose}
    >
      <div
        className="w-full max-w-sm rounded-2xl border border-theme-chatDivider bg-theme-secondaryBackground p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {title && (
          <h3 className="text-base font-semibold text-theme-secondaryText">
            {title}
          </h3>
        )}
        {message && (
          <p className="mt-2 text-sm leading-relaxed text-theme-placeholder">
            {message}
          </p>
        )}
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="rounded-lg border border-theme-chatDivider px-4 py-2 text-sm font-medium text-theme-secondaryText transition-colors hover:bg-theme-tertiaryBackground disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`rounded-lg px-4 py-2 text-sm font-medium transition-opacity hover:opacity-90 disabled:opacity-50 ${
              danger
                ? "bg-theme-error text-white"
                : "bg-theme-secondaryText text-theme-primaryBackground"
            }`}
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
